module.exports = __webpack_public_path__ + "img/13.fd8f5f6e.png";